import { IConsultant } from 'wisestep-api';
import create from 'zustand';

interface ConsultantsStore {
  consultant: IConsultant | null;
  consultants: IConsultant[];
  updateSelectedConsultants(args: IConsultant | null): void;
  removeSelectedConsultant(args: IConsultant): void;
  setSelectedConsultants(args: IConsultant[]): void;
  setSelectedConsultant(args: IConsultant): void;
}

const useConsultantsStore = create<ConsultantsStore>((set) => ({
  consultant: null,
  consultants: [],
  updateSelectedConsultants: (consultant: IConsultant | null) => {
    set((state) => ({
      consultants: consultant ? [...state.consultants, consultant] : [],
    }));
  },
  removeSelectedConsultant: (consultant: IConsultant) => {
    set((state) => ({
      consultants: state.consultants.filter(
        (consultants) => `${consultants.id}` !== `${consultant.id}`
      ),
    }));
  },
  setSelectedConsultants: (consultants: IConsultant[]) => set({ consultants }),

  setSelectedConsultant: (consultant: IConsultant) => set({ consultant }),
}));

export default useConsultantsStore;
